<script setup lang="ts">
    const active = defineModel<boolean>({ default: false });
    withDefaults(
        defineProps<{
            label?: string;
        }>(),
        {
            label: undefined,
        },
    );

    function toggleActive() {
        active.value = !active.value;
    }
</script>

<template>
    <button
        type="button"
        @click="toggleActive"
    >
        <!-- When active, shadow-inner is used for reducing the pixelated effect on the border -->
        <div
            data-test-id="toggle-button"
            :class="[
                active && 'border-border-secondary bg-bg-primary text-white hover:border-hover-primary hover:bg-hover-primary',
                !active && 'border-border-primary bg-white text-text hover:border-border-secondary hover:bg-bg-primary hover:text-white',
                'transition-color m-auto h-8 w-8 overflow-hidden border duration-300',
            ]"
        >
            <slot />
        </div>

        <span v-if="label">{{ label }}</span>
    </button>
</template>
